export default __webpack_public_path__ + "static/media/laboratorioensayos.6448f34c.png";